import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { throwError } from 'rxjs';
import { CmsConfig } from '../../../../../lmh/cms/src/lib/config/cms.config';

class B2CAuthError {
  error: string;
  error_description: string;
}

@Injectable({
  providedIn: 'root',
})
export class MsalService {
  constructor(private route: ActivatedRoute, private baseSiteConfig: CmsConfig,) {}

  public loginRedirect(
     baseUrl: string,
     authority: string,
     clientId: string,
     redirectUri: string,
     defaultLanguage: string
  ): void {
    window.localStorage.setItem('redirectBaseUrl', baseUrl);
    window.localStorage.setItem('redirectAuthority', authority);
    window.localStorage.setItem('redirectClientId', clientId);
    window.localStorage.setItem('redirectUri', redirectUri);
    window.localStorage.setItem('defaultLanguage', defaultLanguage);

    const language = this.getLanguage(defaultLanguage);
    const langUrl = defaultLanguage
       ? '&ui_locales=' + language + '&language=' + language
       : '';
    const authUrl =  baseUrl + '/oauth2/v2.0/authorize?p=' + authority +
       '&client_id=' + clientId +
       '&nonce=defaultNonce&redirect_uri=' + redirectUri +
       '&scope=openid&response_type=id_token&brand=LMH' + langUrl;
    window.location.assign(authUrl);
  }

  private getLanguage(local: string): string {
    if (local !== undefined) {
      const lang = local && local.split('_').length === 2
         ? local.split('_')[0]
         : 'en';
      return lang;
    }
    return '';
  }

  public handleRedirect(): void {
    this.handleError();
    const jwt = this.route.snapshot.fragment.split('id_token=')[1];
    if (!jwt) {
      throwError('could not read jwt');
      return;
    }
    window.localStorage.setItem(
       'account',
       decodeURIComponent(escape(atob(jwt.split('.')[1])))
    );
    window.localStorage.setItem('rawIdToken', jwt);
  }

  public getAccount(): any {
    const account = window.localStorage.getItem('account');
    if (!account) {
      return null;
    }
    return JSON.parse(window.localStorage.getItem('account'));
  }

  public getRawIdToken(): string {
    return window.localStorage.getItem('rawIdToken');
  }

  private handleError() {
    const splitArray = this.route.snapshot.fragment.split('&');
    const paramsMap: B2CAuthError = new B2CAuthError();
    for (const split of splitArray) {
      const keyValueSplit = split.split('=');
      paramsMap[keyValueSplit[0]] = keyValueSplit[1];
    }
    if (
       paramsMap.error_description &&
       paramsMap.error_description.startsWith('AADB2C90091')
    ) {
      this.loginRedirect(
         window.localStorage.getItem('redirectBaseUrl'),
         window.localStorage.getItem('redirectAuthority'),
         window.localStorage.getItem('redirectClientId'),
         window.localStorage.getItem('redirectUri'),
         window.localStorage.getItem('defaultLanguage')
      );
    }
  }
}
